import { render, staticRenderFns } from "./GaranteeData.vue?vue&type=template&id=04ace60a"
import script from "./GaranteeData.vue?vue&type=script&lang=js"
export * from "./GaranteeData.vue?vue&type=script&lang=js"
import style0 from "./GaranteeData.vue?vue&type=style&index=0&id=04ace60a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports